import { ICustomAnimationProps } from "@thekilroygroup/shared-ui";

export const titleAnimations: ICustomAnimationProps = {
  type: "slide",
  delay: 300,
  delayOut: 100,
  timeout: 300,
  direction: "up",
};

export const subtitleAnimations: ICustomAnimationProps = {
  type: "slide",
  delay: 300,
  delayOut: 1,
  timeout: 300,
  direction: "up",
};
